export const buildDismissedSnackbarKey = (appId: string): string => {
  return `quote:${appId.trim()}:weekly-plan-snackbar-dismissed`;
};

export const isDismissedInSession = (storageKey: string): boolean => {
  try {
    return sessionStorage.getItem(storageKey) === 'true';
  } catch {
    return false;
  }
};

export const setDismissedInSession = (storageKey: string): void => {
  try {
    sessionStorage.setItem(storageKey, 'true');
  } catch {
    // Ignore storage failures (private mode, disabled storage, etc.)
  }
};
